import { render } from "./OrganizationsAdmin.vue?vue&type=template&id=7d7614bd&scoped=true"
import script from "./OrganizationsAdmin.vue?vue&type=script&lang=js"
export * from "./OrganizationsAdmin.vue?vue&type=script&lang=js"

import "./OrganizationsAdmin.vue?vue&type=style&index=0&id=7d7614bd&lang=scss&scoped=true"
import "./OrganizationsAdmin.vue?vue&type=style&index=1&id=7d7614bd&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7614bd"]])

export default __exports__